import 'react-app-polyfill/stable'
import 'core-js'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import { Provider } from 'react-redux'
import store from './store'
import { UserContext } from './context/UserContext'
import { ApiMonitoringContext } from './context/ApiMonitoringContext'

ReactDOM.render(
  <Provider store={store}>
    <UserContext>
      <ApiMonitoringContext>
        <App />
      </ApiMonitoringContext>
    </UserContext>
  </Provider>,
  document.getElementById('root'),
)
